<template>
  <v-container>
    <v-row class="mt-5" align="center" justify="center">
      <v-col lg="6" md="8" sm="10" xl="4" cols="12">
        <v-form ref="form" v-model="valid">
          <v-subheader class="pa-0">Gebruiker</v-subheader>
          <v-card class="themed-color">
            <v-card-text>
              <v-text-field
                :counter="100"
                :rules="[(v) => !!v || 'Naam is verplicht', v => serverError('name'), (v) => !!v && v.length <= 100 || 'de naam mag maximaal 100 tekens bevatten']"
                label="Naam"
                required
                v-model="values.name"></v-text-field>
              <v-text-field
                :counter="150"
                :rules="[(v) => !!v || 'E-mail is verplicht', v => serverError('email'), (v) => !!v && v.length <= 100 || 'het e-mailadres mag maximaal 150 tekens bevatten']"
                label="E-mail"
                hint="Het e-mailadres waarmee de gebruiker gaat inloggen en waarnaar een mail verzonden wordt met instructies om een wachtwoord aan te maken"
                required
                v-model="values.email"></v-text-field>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Form from './../BaseForm';

export default {
  name: 'user-form',
  extends: Form,
  methods: {},
};
</script>
